var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-tip-example" }, [
    _c("h2", [_vm._v("TextTip 组件使用示例")]),
    _c("div", { staticClass: "example-item" }, [
      _c("h3", [_vm._v("默认配置（最大20字）")]),
      _c(
        "div",
        { staticClass: "text-container" },
        [_c("TextTip", [_vm._v(_vm._s(_vm.longText))])],
        1
      ),
      _c("p", { staticClass: "description" }, [
        _vm._v(
          " 当文本超过20字时，会显示省略号并在鼠标悬停时显示完整内容的tooltip "
        ),
      ]),
    ]),
    _c("div", { staticClass: "example-item" }, [
      _c("h3", [_vm._v("自定义最大字数（10字）")]),
      _c(
        "div",
        { staticClass: "text-container" },
        [
          _c("TextTip", { attrs: { "max-length": 10 } }, [
            _vm._v(_vm._s(_vm.longText)),
          ]),
        ],
        1
      ),
      _c("p", { staticClass: "description" }, [
        _vm._v(
          " 当文本超过10字时，会显示省略号并在鼠标悬停时显示完整内容的tooltip "
        ),
      ]),
    ]),
    _c("div", { staticClass: "example-item" }, [
      _c("h3", [_vm._v("自定义tooltip位置（底部）")]),
      _c(
        "div",
        { staticClass: "text-container" },
        [
          _c("TextTip", { attrs: { placement: "bottom" } }, [
            _vm._v(_vm._s(_vm.longText)),
          ]),
        ],
        1
      ),
      _c("p", { staticClass: "description" }, [
        _vm._v("tooltip 显示在文本底部"),
      ]),
    ]),
    _c("div", { staticClass: "example-item" }, [
      _c("h3", [_vm._v("自定义tooltip主题（浅色）")]),
      _c(
        "div",
        { staticClass: "text-container" },
        [
          _c("TextTip", { attrs: { effect: "light" } }, [
            _vm._v(_vm._s(_vm.longText)),
          ]),
        ],
        1
      ),
      _c("p", { staticClass: "description" }, [_vm._v("tooltip 使用浅色主题")]),
    ]),
    _c("div", { staticClass: "example-item" }, [
      _c("h3", [_vm._v("不显示省略号")]),
      _c(
        "div",
        { staticClass: "text-container" },
        [
          _c("TextTip", { attrs: { "show-ellipsis": false } }, [
            _vm._v(_vm._s(_vm.longText)),
          ]),
        ],
        1
      ),
      _c("p", { staticClass: "description" }, [
        _vm._v(" 当文本超过限制时，不会显示省略号，但仍会显示tooltip "),
      ]),
    ]),
    _c("div", { staticClass: "example-item" }, [
      _c("h3", [_vm._v("短文本（不显示tooltip）")]),
      _c(
        "div",
        { staticClass: "text-container" },
        [_c("TextTip", [_vm._v(_vm._s(_vm.shortText))])],
        1
      ),
      _c("p", { staticClass: "description" }, [
        _vm._v("当文本未超过限制时，不会显示省略号和tooltip"),
      ]),
    ]),
    _c("div", { staticClass: "example-item" }, [
      _c("h3", [_vm._v("包含HTML标签的文本")]),
      _c(
        "div",
        { staticClass: "text-container" },
        [
          _c("TextTip", { attrs: { "max-length": 15 } }, [
            _vm._v(" 这是一段包含"),
            _c("em", { staticStyle: { color: "red" } }, [_vm._v("强调")]),
            _vm._v("和"),
            _c("u", [_vm._v("下划线")]),
            _vm._v(
              "的文本内容，当它超过指定的字数限制时，会自动显示省略号并在鼠标悬停时通过tooltip显示完整内容。 "
            ),
          ]),
        ],
        1
      ),
      _c("p", { staticClass: "description" }, [
        _vm._v(" 支持包含HTML标签的文本，但tooltip会显示纯文本内容 "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }